/*
 * @Author: Jason
 * @Date: 2025-06-20 09:08:09
 * @LastEditors: Jason
 * @LastEditTime: 2025-07-03 15:38:17
 * @FilePath: /MSFinWeb/src/main.js
 * @Description:
 *
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved.
 */
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from '@/router' // 路由
import '@/router/hooks' // 路由钩子
import Cookies from 'js-cookie'
import i18n from './resources/index'
import * as echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
import VueEasytable from 'vue-easytable'
import { veLoading } from 'vue-easytable'
import 'vue-easytable/libs/theme-default/index.css'
import store from './store'
import Tools from './utils/Tools.js'
import Management from './common/management.js'
import deviceUtil from './common/deviceUtil.js'
import InputView from './components/inputView.vue'
import './assets/svg/index'
import websettings from './websettings.js'
import axios from 'axios'
import paginationCom from '@/components/PaginationCom.vue'
import configManager from './utils/configManager'

import lodash from 'lodash'

// 将 ConfigManager 挂载到 window 对象
window.ConfigManager = configManager
import { shouldShowAnnouncement, clearAnnouncementDismissed } from '@/utils/announcementUtils.js'

Vue.prototype.axios = axios
Vue.prototype.$veLoading = veLoading

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'small',
  i18n: (key, value) => i18n.t(key, value),
})
Vue.use(VueEasytable)
Vue.prototype.$Colors = vuetify.userPreset.theme.themes.light
Vue.prototype.$Tools = Tools
Vue.prototype.$Management = Management //全局变量
Vue.prototype.$deviceUtil = deviceUtil //全局变量
Vue.prototype.$websettings = websettings //web设置全局变量
Vue.prototype.$otaSssids = [] //全局变量
Vue.prototype.$commandRecord = [] //全局指令记录
Vue.prototype.$addressCache = new Map() //全局地址缓存变量
Vue.prototype.GLOBAL = App //全局变量
Vue.prototype.$lodash = lodash //防抖节流
Vue.prototype.$pageParams = Vue.prototype.$pageParams || { videoPlayback: {} } //全局记录界面自定义参数
Vue.prototype.$stringFormat = function stringFormat(formatted, args) {
  for (let i = 0; i < args.length; i++) {
    let regexp = new RegExp('\\{' + i + '\\}', 'gi')
    formatted = formatted.replace(regexp, args[i])
  }
  return formatted
}
// Vue.use(Element, {
//
// })

Vue.component('InputView', InputView)
Vue.component('paginationCom', paginationCom)
deviceUtil.that = Vue.prototype

// 全局调试函数
window.clearAnnouncementDismissed = clearAnnouncementDismissed
window.shouldShowAnnouncement = shouldShowAnnouncement

async function initApp() {
  try {
    if (window.ConfigManager) {
      await window.ConfigManager.loadConfig()
    }

    // 初始化 menuTagList - 合并默认列表与缓存，确保新添加的项目不会丢失
    store.dispatch('tagsView/initializeMenuTagList')

    // 创建 Vue 实例和其他初始化代码
    new Vue({
      i18n,
      router,
      vuetify,
      store,
      render: (h) => h(App),
    }).$mount('#app')
  } catch (error) {
    console.error('Failed to initialize app:', error)
  }
}

initApp()
